<template>
  <div>
    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="listaClassificacoes"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    />

    <div class="text-right mb-3">
      <fcc-button @click="importar" :disabled="dadosSelecionados.length === 0">Importar</fcc-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['listaClassificacoes'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'codigoclass', label: 'Código', sortable: true },
        { key: 'opcaoclass', label: 'Opção de Classificação', sortable: true },
        { key: 'rotulo', label: 'Rótulo', sortable: true }
      ],
      itemsPorPage: '10',
      dadosSelecionados: []
    }
  },
  methods: {
    selecionaLinha(value) {
      this.dadosSelecionados = value
    },
    importar() {
      this.$emit('importar', this.dadosSelecionados)
    }
  }
}
</script>